/*
  VAWZINE — in-page anchors for JSON-template sections.

  Section wrappers are rendered as `shopify-section-template--<id>__<key>`, where <key>
  is the section key in the template JSON (e.g. "inside", "look-inside", "faq").
  This adds a plain anchor (#inside) at the top of each keyed section so menu links
  like "/#inside" work from any page, then offsets the scroll for the sticky header.
*/
(() => {
  const KEYS = ['inside', 'look-inside', 'faq', 'promise', 'offer', 'fit', 'compare', 'outcomes', 'transformation', 'value'];

  function addAnchors() {
    KEYS.forEach((key) => {
      if (document.getElementById(key)) return;
      const section = document.querySelector(`[id^="shopify-section-template"][id$="__${key}"]`);
      if (!section) return;
      const anchor = document.createElement('span');
      anchor.id = key;
      anchor.className = 'vz-anchor';
      section.prepend(anchor);
    });
  }

  function scrollToHash(hash, smooth) {
    if (!hash || hash.length < 2) return false;
    let target;
    try {
      target = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (e) {
      return false;
    }
    if (!target) return false;
    const header = document.querySelector('.section-header');
    const offset = (header ? header.offsetHeight : 0) + 12;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    return true;
  }

  function closeMenuDrawer() {
    const details = document.querySelector('#Details-menu-drawer-container');
    if (!details || !details.hasAttribute('open')) return;
    const summary = details.querySelector('summary');
    if (summary) summary.click();
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
    if (!document.getElementById(url.hash.slice(1))) return;
    event.preventDefault();
    closeMenuDrawer();
    history.pushState(null, '', url.hash);
    scrollToHash(url.hash, true);
  });

  document.addEventListener('DOMContentLoaded', () => {
    addAnchors();
    if (window.location.hash) {
      // Wait a frame so images/fonts above the target don't shift it after we scroll.
      window.requestAnimationFrame(() => scrollToHash(window.location.hash, false));
    }
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', addAnchors);
  }
})();
